"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const ArrowUp2 = _ref => {
  let {
    title = 'Up Arrow',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.5 28.1h-3V9.9l-8.3 8.3L4 16.1l12-12l12 12l-2.2 2.2l-8.3-8.3V28.1z"
  }));
};
var _default = exports.default = (0, _ikon.default)(ArrowUp2);
ArrowUp2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowUp2",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Up Arrow'",
        "computed": false
      },
      "required": false
    }
  }
};